import React, {useContext} from "react";
import GenericDialog from '../common/GenericDialog';
import {ContentContext} from "../common/ContentContext";
import MediaPlayer from "./MediaPlayer";
import {FullscreenIcon} from "../common/icons";
import CircularLoader from "../common/CircularLoader";
import {BrandContext} from "../common/BrandContext";

const MediaPlayerDialog = props => {
    const {open = false} = props;
    const brandConfig = useContext(BrandContext);
    const {dialogMediaObject, setDialogMediaObject} = useContext(ContentContext);
    const DIALOG_WIDTH_OBJ = {
        WIDGET: 600,
        VIDEO: 900,
        SCORCHER: 970,
        DESMOS: 900,
        DESMOS_GRAPHING: 900,
        DESMOS_GEOMETRY: 1000,
        DESMOS_SCIENTIFIC: 800,
        DESMOS_MATRIX: 800,
    }
    const MEDIA_TYPE = {
        VIDEO: {name: brandConfig.videoName},
        WIDGET: {name: brandConfig.widgetName},
        DESMOS: {name: brandConfig.desmosName},
        SCORCHER: {name: brandConfig.scorcherName},
    }

    const handleClose = () => {
        setDialogMediaObject(null);
        if (typeof dialogMediaObject?.callback === 'function') dialogMediaObject?.callback();
    }

    return (
        <GenericDialog
            open={open}
            title={dialogMediaObject?.mediaName ? dialogMediaObject.mediaName : MEDIA_TYPE[dialogMediaObject?.mediaType]?.name}
            buttons={[{name: 'Close'}]}
            onClose={handleClose}
            dialogWidth={DIALOG_WIDTH_OBJ[(dialogMediaObject?.mediaType === 'DESMOS' && dialogMediaObject?.mediaSubType) ? dialogMediaObject?.mediaSubType : dialogMediaObject?.mediaType]}
            allowFullScreen={dialogMediaObject?.mediaType !== 'VIDEO'}
        >
            <MediaPlayer mediaId={dialogMediaObject?.mediaId} mediaType={dialogMediaObject?.mediaType} conceptId={dialogMediaObject?.conceptId} />
        </GenericDialog>
    )
}

export default MediaPlayerDialog;